<template>
    <el-button type="primary" size="small">
        <slot></slot>
    </el-button>
</template>
